import { RestartAlt } from "@mui/icons-material";
import { useStore } from "@priolo/jon";
import ButtonCmp from "components/controls/buttons/ButtonCmp";
import MetadataTableFooter from "pages/plc/metadata/TableFooter";
import { NATSPublish } from "plugins/nats";
import { FunctionComponent, useMemo } from "react";
import farmSo from "stores/farm";
import metaSo from "stores/metadata";
import querySo from "stores/route/query";
import { getAlarmAckVarName, getAlarmRows } from "./utils";
import { URL_PAR } from "stores/route/utils/types";
import { ALARM_KINDS, PROPERTIES_TAB } from "./types";
import { Box } from "@mui/material";



const PropertiesFooter: FunctionComponent = () => {

	// STORE
	useStore(metaSo)
	useStore(farmSo)
	useStore(querySo)

	// HOOKs
	const service = useMemo(() => {
		return farmSo.state.componentSelect?.subjects?.[0]
	}, [farmSo.state.componentSelect])

	// le variabili di ACK di tutti gli allarmi (analogici e digitali) del componente
	const ackVarNames = useMemo<string[]>(() => ALARM_KINDS.flatMap(
		kind => getAlarmRows(service, kind).map(row => getAlarmAckVarName(kind, row.index))
	), [service, metaSo.state.metadata])

	// HANDLERs
	/** resetta tutti gli allarmi mandando 1 sulla variabile di ACK di ogni riga delle tabelle */
	const handleAnalogReset = () => {
		// for (const varName of ackVarNames) {
		// 	const meta = metaSo.getMetadata({ serviceCode: service, name: varName })
		// 	NATSPublish(service, meta?.alias ?? varName, 1)
		// }
		NATSPublish(service, "AALXXX_fAlarm_ACK", 1)
	}
	const handleDigitalReset = () => {
		NATSPublish(service, "DALXXX_fAlarm_ACK", 1)
	}

	// RENDER

	// TAB selezionato
	const tab = querySo.getSearchUrl(URL_PAR.TAB_SEL) as PROPERTIES_TAB

	return <>

		{tab == PROPERTIES_TAB.PROPERTIES ? (
			<MetadataTableFooter readonly />
		) : (
			<Box sx={{ ml: "26px" }} />
		)}

		{tab == PROPERTIES_TAB.ANALOG && (
			<ButtonCmp 
				startIcon={<RestartAlt />}
				disabled={!(ackVarNames.length > 0)}
				onClick={handleAnalogReset}
			>RESET ANALOG</ButtonCmp>
		)}

		{tab == PROPERTIES_TAB.DIGITAL && (
			<ButtonCmp 
				startIcon={<RestartAlt />}
				disabled={!(ackVarNames.length > 0)}
				onClick={handleDigitalReset}
			>RESET DIGITAL</ButtonCmp>
		)}

	</>
}

export default PropertiesFooter
